import {useQuery, UseQueryResult} from '@tanstack/react-query'

import {QueryKeyName, getActionsByTopicId} from '../../common/backend'
import {ActionItem} from '../../types'
import {usePlantUpmId} from '../usePlantUpmIdContext'

export const useTopicActions = (topicId: string): UseQueryResult<ActionItem[]> => {
  const plantId = usePlantUpmId()

  return useQuery({
    queryKey: [QueryKeyName.GetActionItems, plantId, topicId],
    queryFn: async () => {
      return await getActionsByTopicId({plantId, topicId})
    }
  })
}
